const database = () => new Promise((resolve, reject) => {
  const request = indexedDB.open('bigsix-deposit-drafts', 1);
  request.onupgradeneeded = () => request.result.createObjectStore('drafts', { keyPath: 'id' });
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});
const operation = async (mode, action) => {
  const db = await database();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction('drafts', mode);
    const request = action(transaction.objectStore('drafts'));
    transaction.oncomplete = () => { db.close(); resolve(request.result); };
    transaction.onerror = () => { db.close(); reject(transaction.error); };
    transaction.onabort = () => { db.close(); reject(transaction.error || new Error('Draft storage aborted')); };
  });
};
export const saveLocalDraft = (draft) => operation('readwrite', (store) => store.put(draft));
export const getLocalDraft = async (id, userId) => {
  const draft = await operation('readonly', (store) => store.get(id));
  return draft && String(draft.userId) === String(userId) ? draft : null;
};
export const listLocalDrafts = async (userId) => (await operation('readonly', (store) => store.getAll())).filter((draft) => String(draft.userId) === String(userId));
export const deleteLocalDraft = (id) => operation('readwrite', (store) => store.delete(id));
export const newDraftId = () => crypto.randomUUID ? crypto.randomUUID() : '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (character) => (Number(character) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(character) / 4)))).toString(16));
